<template>
  <div class="w-full | recaptcha">
    <vue-recaptcha :sitekey="sitekey" :loadRecaptchaScript="true" theme="dark" @verify="verify" ref="recaptcha"></vue-recaptcha>
    <p v-if="error" class="text-sm text-red-8 mt-1 pl-1">{{ error }}</p>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
export default {
  name: "Captcha",
  props: {
    id: {
      required: true
    },
    errors: {
      required: true
    }
  },
  components: {
    VueRecaptcha
  },
  data() {
    return {
      sitekey: process.env.VUE_APP_RECAPTCHA_SITEKEY
    }
  },
  computed: {
    error() {
      if (!this.errors) return false
      return this.errors.has(this.id) ? this.errors.first(this.id) : false
    }
  },
  methods: {
    verify(response) {
      this.$emit('response', response)
    },
    reset() {
      this.$refs.recaptcha.reset()
    }
  }
}
</script>

<style lang="scss">
.recaptcha > div > div {
  @apply mx-auto;
}
</style>
